import { computed, makeObservable } from 'mobx'
import type { Moment } from 'moment'

import { stringToDate } from 'modules/core/lib/dates'
import { Model } from 'modules/core/lib/mobx-rest'

import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'
import timeoffAllowances from 'modules/timeoff/store/collections/allowances'

import TimeoffAllowance from './Allowance'

interface IAllowanceIncidence {
  [key: string]: any
}

class AllowanceIncidence extends Model<IAllowanceIncidence> {
  constructor(attr: IAllowanceIncidence = {}) {
    super(attr)
    makeObservable(this, {
      employee: computed,
      units: computed,
      allowanceType: computed,
      cycleStart: computed,
      cycleEnd: computed,
      description: computed,
      targetBalance: computed,
    })
  }

  static urlRoot() {
    return '/api/rest/timeoff/allowance_incidences'
  }

  get employee(): Employee {
    return employees.relatedTo(this)
  }

  get units(): number {
    return this.attributes.days_in_cents
  }

  get effectiveOn(): Moment {
    return stringToDate(this.attributes.effective_on, 'backend')
  }

  get cycleStart(): string {
    return stringToDate(this.attributes.start_at, 'backend').format('MMM YYYY')
  }

  get cycleEnd(): string {
    return stringToDate(this.attributes.end_at, 'backend').format('MMM YYYY')
  }

  get description(): string {
    return this.attributes.description
  }
  get targetBalance(): string {
    return this.attributes.target_balance
  }

  get allowanceType(): string {
    const allowance = timeoffAllowances.find({ id: this.attributes.timeoff_allowance_id })

    if (!allowance) {
      return TimeoffAllowance.ALLOWANCE_TYPES.days
    }

    return allowance.attributes.allowance_type
  }
}

export default AllowanceIncidence
